import React from 'react';
const TicketStatusTag = ({ ticketStatus }) => {
  return <span className="appn-ticket-status-tag">{ticketStatus}</span>;
};

export default TicketStatusTag;
